import React from 'react';
import PickEmRules from '../shared/PickEmRules';
import BackToRulesLink from './BackToRulesLink';
import PublicRulesLayout from './PublicRulesLayout';

export default function PickEmRulesPage() {
  return (
    <PublicRulesLayout>
      <PickEmRules title="Pick 'Em League Rules" headerAction={<BackToRulesLink />} />
    </PublicRulesLayout>
  );
}
